<template>
    <div>
        <b-nav-item :href="url" :title="tooltip" v-b-tooltip.hover>
            <img :src="require(`@/assets/${imgsrc}`)" />
        </b-nav-item>
    </div>
</template>

<script>
export default {
    props: [
        "url",
        "tooltip",
        "imgsrc"
    ]
}
</script>

<style scoped>
    .navbar .nav-item img {
        height: 40px;
    }
</style>